export default {
  activateText: 'æ¾å¼ç«å³å·æ°',
  deactivateText: 'ä¸æå¯ä»¥å·æ°',
  finishText: 'å®æå·æ°',
};
